import React, { useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import Pagination from "../../Utils";
import { useQuery } from "@tanstack/react-query";
import { ErrorToast } from "../../Utils/SweetAlert";
import { Formik } from "formik";
import SearchBox from "../../Components/SearchBox";
import { GetCustomNotificationList } from "../../Api/customNotification";
import AddButton from "../../Components/AddButton";
import { StatusButton } from "../../Components";
import AddNotificationModal from "./components/AddNotificationModal";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";
import { checkPermission } from "../../Utils/permissionHelper";
import "./style.css";
import SaveButton from '../../Components/SaveButton';

const CustomNotificationList = () => {
  const formRef = useRef();
  const [showAddModal, setShowAddModal] = useState(false);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const {
    isFetching: isLoading,
    data: notificationList,
    refetch,
  } = useQuery({
    queryKey: ["get-custom-notifications-list", page, limit],
    queryFn: () =>
      GetCustomNotificationList({
        limit: limit,
        page: page === 0 ? 1 : page + 1,
        search: formRef?.current?.values?.search || "",
      }),
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    },
  });

  const handlePageChange = (e, pageNew) => {
    setPage(pageNew);
  };

  const handleLimitChange = (event) => {
    setPage(0);
    setLimit(parseInt(event.target.value, 10));
  };

  return (
    <>
      <Helmet>
        <title>OVE | Admin Custom Notifications</title>
      </Helmet>
      <div className="page-wrapper app-notification custom-notification-module">
        <div className="content container-fluid">
          <div className="admin-wrapper">
            <div className="page-header">
              <div className="col">
                <h1 className="page-title">Custom Notifications</h1>
              </div>
              <div className="d-flex align-items-center gap-2">
                <div style={{ width: "200px" }}>
                  <Formik initialValues={{ search: "" }} innerRef={formRef}>
                    <SearchBox refetch={refetch} setPage={setPage} />
                  </Formik>
                </div>
                <AddButton
                  onClick={() => setShowAddModal(true)}
                  permission="create-custom-notification"
                >
                  Send
                </AddButton>
              </div>
            </div>

            <div className="col-sm-12 table-width">
              <div className="cards-table card-table">
                <div className="card-body">
                  <div className="table-responsive custom-pagination table-no-padding">
                    <table className="table datatable table-manager mb-0" style={{ width: "100%" }}>
                      <thead className="thead-light">
                        <tr>
                          <th className="text-start" style={{ width: "25%" }}>Title</th>
                          <th className="text-start" style={{ width: "35%" }}>Message</th>
                          <th className="text-center" style={{ width: "15%" }}>Send to All</th>
                          <th className="text-center" style={{ width: "25%" }}>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <tr>
                            <td align="center" colSpan={4}>
                              <div className="d-flex justify-content-center align-items-center py-4">
                                <div className="spinner-border loader-theme" role="status" />
                              </div>
                            </td>
                          </tr>
                        )}
                        {!isLoading && notificationList !== undefined && (
                          <>
                            {notificationList?.data?.data.map((item, index) => (
                              <tr key={index}>
                                <td className="text-start">
                                  <Tooltip title={item?.title} placement="top-start" arrow>
                                    <span className="category-cell-ellipsis">
                                      {item?.title?.length >= 35
                                        ? item?.title.substring(0, 30) + "..."
                                        : item?.title || "-"}
                                    </span>
                                  </Tooltip>
                                </td>
                                <td className="text-start">
                                  <Tooltip title={item?.message} placement="top-start" arrow>
                                    <span className="category-cell-ellipsis">
                                      {item.message?.length >= 60
                                        ? item.message.substring(0, 55) + "..."
                                        : item.message || "-"}
                                    </span>
                                  </Tooltip>
                                </td>
                                <td className="text-center">
                                  {item?.isSendAll ? "Yes" : "No"}
                                </td>
                                <td className="text-center">
                                  {item?.createdAt ? moment(item.createdAt).format("DD/MM/YYYY") : "-"}
                                </td>
                              </tr>
                            ))}
                            {notificationList?.data?.data?.length === 0 && (
                              <tr>
                                <td className="text-center" colSpan={4}>
                                  No Records Found.
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <Pagination
              totalItem={notificationList?.data?.totalRecords || 0}
              itemsPerPage={limit}
              page={!notificationList?.data?.totalRecords || notificationList?.data?.totalRecords <= 0 ? 0 : page}
              handleChangePage={handlePageChange}
              handleChangeRowsPerPage={handleLimitChange}
              colSpan={4}
            />
          </div>
        </div>
      </div>

      <AddNotificationModal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        onSuccess={() => refetch()}
      />
    </>
  );
};

export default CustomNotificationList;
